import React, { useEffect, useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "./components/ui/sonner";
import HomePage from "./pages/HomePage";
import UploadPage from "./pages/UploadPage";
import PricingPage from "./pages/PricingPage";
import ResultsPage from "./pages/ResultsPage";
import PaymentSuccessPage from "./pages/PaymentSuccessPage";
import SignInPage from "./pages/SignInPage";
import RegisterPage from "./pages/RegisterPage";
import TermsPage from "./pages/TermsPage";
import PrivacyPage from "./pages/PrivacyPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import AdminEmailSignupsPage from "./pages/AdminEmailSignupsPage";
import AdminAnalyticsPage from "./pages/AdminAnalyticsPage";
import GeoBlockedPage from "./pages/GeoBlockedPage";

function App() {
  const [isGeoBlocked, setIsGeoBlocked] = useState(false);
  const [checkingGeo, setCheckingGeo] = useState(true);

  useEffect(() => {
    // Apply dark mode to document
    document.documentElement.classList.add('dark');
    document.body.classList.add('dark');

    // Check geo-blocking status
    const checkGeoAccess = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/geo-check`);
        if (response.status === 451) {
          setIsGeoBlocked(true);
        }
      } catch (error) {
        console.error("Geo-check failed:", error);
      } finally {
        setCheckingGeo(false);
      }
    };

    checkGeoAccess();
  }, []);

  if (checkingGeo) {
    return <div className="min-h-screen bg-slate-900 flex items-center justify-center"><div className="spinner"></div></div>;
  }

  if (isGeoBlocked) {
    return <GeoBlockedPage />;
  }

  return (
    <HelmetProvider>
      <div className="App dark">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/upload" element={<UploadPage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/results/:requestId" element={<ResultsPage />} />
            <Route path="/payment-success" element={<PaymentSuccessPage />} />
            <Route path="/signin" element={<SignInPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/admin/email-signups" element={<AdminEmailSignupsPage />} />
            <Route path="/admin/analytics" element={<AdminAnalyticsPage />} />
            <Route path="*" element={<div className="min-h-screen bg-gray-900 text-white flex items-center justify-center"><div className="text-center"><h1 className="text-2xl mb-4">404 - Page Not Found</h1><p>The page you're looking for doesn't exist.</p></div></div>} />
          </Routes>
          <Toaster />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;